import {Component, OnInit} from '@angular/core';
import {HttpEventType, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {FileUploadService} from "./file-upload.service";
import {environment} from "../../environments/environment";
import {Item} from "./upload-item";
import {TokenStorageService} from "../_services/token-storage.service";
import {BreadcrumbService} from "xng-breadcrumb";
import {Dimensions, ImageCroppedEvent, ImageTransform} from "ngx-image-cropper";
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from "@angular/router";

@Component({
  standalone: false,
  selector: 'app-add-item',
  templateUrl: './add-item.component.html',
  styleUrls: ['./add-item.component.css'],
  imports: [FormControl]
})
export class AddItemComponent implements OnInit {
  selectedFiles?: FileList;
  selectedFileNames: string[] = [];
  progressInfos: any[] = [];
  message: string[] = [];
  messages: string[] = [];
  previews: string[] = [];
  imageInfos?: Observable<any>;

  url: any;
  imageSrc: any;
  counties: any;
  categoriesArray: Array<any> = new Array();
  subCategoriesArray: any;
  countiesArray: Array<any> = new Array();
  categories: any;
  subcategory: any = '';
  value: any = '';
  userId: any = '';
  category: any = '';
  item: any = '';
  description: any = '';
  county: any = '';
  town: any = '';

  step1: any;
  step2: any;
  step3: any;
  step4: any;
  itemToSave: Item;
  myItem: any;
  imgCount: any;
  currentUser: any;
  form: any;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  file: File;
  canvasRotation = 0;
  rotation = 0;
  scale = 1;
  showCropper = false;
  containWithinAspectRatio = false;
  transform: ImageTransform = {};
  loginForm: FormGroup;
  submitted = false;
  spinner = false;
  isEditMode = false;

  constructor(private token: TokenStorageService,
              private route: ActivatedRoute,
              private uploadService: FileUploadService,
              private breadcrumbService: BreadcrumbService,
              private formBuilder: FormBuilder) {
    environment.then(environment => {
      this.url = environment["backendURL"];
      this.imageSrc = environment["images"];
    });
  }

  ngOnInit(): void {
    console.log('1 TESTER123');
    this.route.queryParams.subscribe(params => {
      if (params['edit']) {
        console.log('TESTER123');
        this.isEditMode = true;
        this.loadItemForEdit(params['edit']);
      }
    });
    this.loginForm = this.formBuilder.group({
      item: ['Playstation', [Validators.required]],
      description: ['2nd hand in good condition. has 3 games. As good as new', Validators.required],
      value: ['200', Validators.required],
      category: ['', Validators.required],
      subcategory: ['', Validators.required],
      location: ['Kerry', Validators.required],
      town: ['Tralee', Validators.required]
    });
    this.breadcrumbService.set('@AddItem', 'Add Item');

    this.currentUser = this.token.getUser();
    console.log(this.currentUser);
    this.step1 = true;
    this.step2 = false;
    this.step3 = false;
    this.step4 = false;
    // this.imageInfos = this.uploadService.getFiles(this.url);
    this.uploadService.getCategories(this.url + '/all-categories')
      .subscribe(response => {
        console.log('categories',response);

        this.categories = response;
        this.categories.forEach(obj => {
          if (!this.categoriesArray.includes(obj)) {
            this.categoriesArray.push(obj);
          }
        });
      });
    this.uploadService.getCounties(this.url + '/counties')
      .subscribe(response => {
        this.counties = response;
        this.counties.forEach(obj => {
          if (!this.countiesArray.includes(obj.name)) {
            this.countiesArray.push(obj.name);
          }
        });
      });
  }

  private loadItemForEdit(itemId: string) {
    // Load item data and populate form
    this.uploadService.getItem(this.url, itemId).subscribe(item => {
      // this.populateForm(item);
      console.log(item);
    });
  }

  onSelectedCategory(value: any): void {
    this.category = value.value;
    this.subCategoriesArray = [];
    this.uploadService.getSubCategories(this.url + '/subcategoriesByCategory', this.category)
      .subscribe(response => {
        this.subCategoriesArray = response;
        console.log('response',response);

      });

    /*this.categories.forEach(o => {
      if (o.categoryByCategoryId.name === value &&
        !this.subCategoriesArray.includes(o.name)) {
        this.subCategoriesArray.push(o.name);
      }
    });*/
  }

  onSelectedSubCategory(value: any): void {
    console.log(value.value, this.subCategoriesArray);
    this.subCategoriesArray.forEach(obj => {
      if (obj.name === value.value.name) {
        this.subcategory = obj.subCategoryId;
        console.log('this.subcategory',this.subcategory);
      }
    });

  }

  onCategory(value: string): void {
    this.category = value;
  }

  onSelectedCounty(value: any): void {
    this.county = value.value;
  }

  saveOne() {
    this.checkForm();
    this.step1 = false;
    this.step3 = true;
    this.step4 = false;
    this.step2 = false;
  }

  checkForm() {
    this.item = this.loginForm.controls.item.value;
    this.description = this.loginForm.controls.description.value;
    this.category = this.loginForm.controls.category.value;
    this.county = this.loginForm.controls.location.value;
    this.town = this.loginForm.controls.town.value;
    this.value = this.loginForm.controls.value.value;
    this.userId = this.currentUser.username;
    console.log('test1', this.item, this.description, this.category, this.subcategory, this.county, this.value);
    if (this.item.length > 3 && this.description.length > 0 && this.county.length > 0
      && this.category.length > 0 && this.subcategory) {

      console.log('madeIt 1');

      this.itemToSave = new Item();
      this.itemToSave.item = this.item;
      this.itemToSave.description = this.description;
      this.itemToSave.location = this.getLocationId();
      this.itemToSave.town = this.town;
      this.itemToSave.category = this.category;
      this.itemToSave.subcategory = this.subcategory;
      this.itemToSave.value = this.value;
      this.itemToSave.userId = this.currentUser.username;

      if (this.itemToSave) {
        console.log('madeIt 2', this.itemToSave);
        this.uploadService.saveItem(this.url, this.itemToSave).subscribe(
          response => {
            this.myItem = response;
            this.imgCount = this.myItem.itemId;
            console.log(this.myItem, this.step3);
          },
          err => {
            console.log(err.error.message);

          });
        console.log(this.myItem);
      }
      if (document.getElementById('step1') != null) {
        console.log('test2');

        setTimeout(function () {
          (document.getElementById('step1')as any).disabled = false;
        }, 500);
      }
    }
  }

  selectFiles(event: any): void {
    this.message = [];
    this.progressInfos = [];
    this.selectedFileNames = [];
    this.selectedFiles = event.target.files;

    this.previews = [];
    if (this.selectedFiles && this.selectedFiles[0]) {
      const numberOfFiles = this.selectedFiles.length;
      for (let i = 0; i < numberOfFiles; i++) {
        const reader = new FileReader();

        reader.onload = (e: any) => {
          console.log(e.target.result);
          this.previews.push(e.target.result);
        };

        reader.readAsDataURL(this.selectedFiles[i]);

        this.selectedFileNames.push(this.selectedFiles[i].name);
      }
    }
  }

  uploadFiles(): void {
    this.message = [];

    if (this.selectedFiles) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        this.upload(i, this.selectedFiles[i]);
      }
    }
  }

  updateItem(): void {
    this.uploadService.updateItem(this.url, this.myItem.itemId).subscribe(
      response => {
        this.myItem = response;
        console.log(this.myItem);
      },
      err => {
        console.log(err.error.message);

      });
  }

  upload(idx: number, file: File): void {
    this.progressInfos[idx] = { value: 0, fileName: file.name };

    if (file) {
      this.uploadService.upload(file, this.url, this.myItem.itemId).subscribe(
        (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progressInfos[idx].value = Math.round( (100 * event.loaded) / event.total);
          } else if (event instanceof HttpResponse) {
            const msg = file.name + ": Successful!";
            this.message.push(msg);
            this.imageInfos = this.uploadService.getFiles(this.url,this.myItem.itemId);
            console.log(this.imageInfos, event);
          }
        },
        (err: any) => {
          this.progressInfos[idx].value = 0;
          let msg = file.name + ": Failed!";

          if (err.error && err.error.message) {
            msg += " " + err.error.message;
          }

          this.message.push(msg);
        }
      );
    }
  }


  private getLocationId() {
    let val = '';
    this.counties.forEach(obj => {
      if (obj.name === this.county) {
        val = obj.locationId;
      }
    });
    return val;
  }

  private getSubcategoryId() {
    let val: any;
    this.subCategoriesArray.forEach(obj => {
      console.log(obj);
      if (obj.name === this.subcategory) {
        val = obj.id;
      }
    });
    console.log('val', val);
    return val;
  }
}
